import { Form, TextField, useForm, yup, yupResolver } from 'form';
import { useTranslation } from 'i18n';
import { Button } from 'ui';

export type OtpFormValues = {
  email_verification_code: string;
};

export const OtpForm = ({ onSubmit, isLoading }: { isLoading: boolean; onSubmit: (data: OtpFormValues) => void }) => {
  const { t } = useTranslation('features');
  const schema = yup.object().shape({
    email_verification_code: yup
      .string()
      .matches(/^[0-9]+$/, t('auth.otpForm.validation.digitsOnly'))
      .required(t('auth.otpForm.validation.passcodeRequired'))
      .min(4, t('auth.otpForm.validation.passcodeLength'))
      .max(4, t('auth.otpForm.validation.passcodeLength')),
  });

  const form = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Form {...form} onSubmit={onSubmit} data-testid="otp-form">
      <TextField
        type="text"
        name="email_verification_code"
        size="medium"
        label={t('auth.otpForm.labels.passcode')}
        required
        autoFocus
        fullWidth
      />
      <Button type="submit" size="large" loading={isLoading}>
        {t('auth.otpForm.actions.signIn')}
      </Button>
    </Form>
  );
};
